import React, { Component } from 'react';
import emptycart from "../../assets/img/empty-shoppingcart.png";
import { CartContext } from '../../components/ParadigmaCartProvider/ParadigmaCartProvider';
import format from "../../functions/functions.js";
import CantidadSelector from '../../components/CantidadSelector/CantidadSelector';
import FreeShipping from '../../components/ShippingComponent/Shipping.js';
import logo from "../../assets/img/brand/LogoWeb.png";
import LoadingScreen from "react-loading-screen";
import Swal from 'sweetalert2';
import apifunctions from '../../api/functions';
import api from '../../api/api';
import "./styles.scss";

class CartMenu extends Component {
    static contextType = CartContext;

    state = {
        cartItems: [],
        porcentajeIVA: 0,
        porcentajeIIBB: 0,
        montoIVA: 0,
        montoIIBB: 0,
        subtotal: 0,
        loaded: false,
        total: 0,
        previousContextSelectedItems: null,
        hasFreeShipping: false,
        remainingAmount: 0
    };

    componentDidMount() {
        this.updateCartData(this.context.selectedItems, 0, this.state.loaded);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.previousContextSelectedItems !== this.context.selectedItems) {
            this.updateCartData(this.context.selectedItems, 0, this.state.loaded);
            this.setState({ previousContextSelectedItems: this.context.selectedItems });
        }
    }

    handleFreeShippingChange = (hasFreeShipping) => {
        this.setState({ hasFreeShipping });
    };

    handleRemainingAmount = (remainingAmount) => {
        this.setState({ remainingAmount });
    };


    updateCartData = (carrito, idformapago, loaded) => {
        this.setState({ loaded: false });
        let params = {
            cart: carrito.map(item => ({
                code: item.code,
                quantity: item.quantity,
                checked: true,
                quantityBahiaBlanca: item.quantityBahiaBlanca || 0,
                quantityBuenosAires: item.quantityBuenosAires || 0,
                quantityCordoba: item.quantityCordoba || 0
            })),
            FormaPago: idformapago
        };
        params = btoa(JSON.stringify(params));
        apifunctions.post(
            api.api.generatecart,
            null,
            { hash: params },
            response => {
                this.setState(prevState => {
                    this.lock = false;
                    let compare = (a, b) => {
                        return a.code > b.code ? 1 : a.code < b.code ? -1 : 0;
                    };
                    prevState.loaded = loaded;
                    prevState.cartItems = response.data.productos || [];
                    prevState.cartItems.sort(compare);
                    prevState.porcentajeIVA = response.data.PorcentajeIVA || 0;
                    prevState.porcentajeIIBB = response.data.PorcentajeIIBB || 0;
                    prevState.montoIVA = response.data.MontoIVA || 0;
                    prevState.montoIIBB = response.data.MontoIIBB || 0;
                    prevState.subtotal = response.data.SubTotal || 0;
                    prevState.total = response.data.Total || 0;
                    return prevState;
                });
            },
            () => {
                this.lock = false;
            },
            () => {
                this.lock = false;
            }
        ).finally(() => {
            this.setState({ loaded: true });
        });
    }

    render() {
        const { cartItems, loaded, total, montoIVA, montoIIBB, subtotal, hasFreeShipping } = this.state;
        let IdGrupo =  localStorage.getItem("Grupo_id")
        return (
            <div className="cartHover_menu">
                <LoadingScreen
                    loading={!loaded}
                    spinnerColor="#9ee5f8"
                    logoSrc={logo}>
                    <div className="cartHover_display">
                        {cartItems.length > 0 ? (
                            cartItems.map(item => (
                                <div key={item.code} className="cartHover_item">
                                    <button
                                        className="btn btn-danger rounded-pill mb-2 pull-right" 
                                        onClick={e => {
                                            e.preventDefault();
                                            this.context.removeItem(item.code)
                                        }}
                                    >
                                        X
                                    </button>
                                    <div className="cartHover_item_header">
                                        <img src={api.BASE_URL + item.images[0]} className="cartHover_item_image" alt={item.Titulo} />
                                        <p className="cartHover_item_title">{item.Titulo}</p>
                                    </div>
                                    {item.checked && (
                                        <ul className="cartHover_stock_list">
                                            {item.stock_bsas > 0 &&  IdGrupo !=="20" && (
                                                <li className="cartHover_stock_item">
                                                    <p className="cartHover_stock_location">Buenos Aires</p>
                                                    <CantidadSelector
                                                        className="cartHover_cantidad_selector"
                                                        cantidadDisponible={999}
                                                        cantidad={item.quantityBuenosAires}
                                                        onChange={quantity =>
                                                            this.context.setItem(
                                                                item.code,
                                                                quantity,
                                                                "buenos_aires"
                                                            )}
                                                    />
                                                </li>
                                            )}
                                            
                                            <li className="cartHover_stock_item">
                                                <p className="cartHover_stock_location">Bahía Blanca</p>
                                                <CantidadSelector
                                                    className="cartHover_cantidad_selector"
                                                    cantidadDisponible={999}
                                                    cantidad={item.quantityBahiaBlanca}
                                                    onChange={quantity =>
                                                        this.context.setItem(
                                                            item.code,
                                                            quantity,
                                                            "bahia_blanca"
                                                        )}
                                                    />
                                            </li>
                                            {/*Deposito CORDOBA*/}
                                            {item.stock_cordoba > 0 && IdGrupo==="20" &&  (
                                                <li className="cartHover_stock_item">
                                                    <p className="cartHover_stock_location">Córdoba</p>
                                                    <CantidadSelector
                                                        className="cartHover_cantidad_selector"
                                                        cantidadDisponible={999}
                                                        cantidad={item.quantityCordoba}
                                                        onChange={quantity =>{
                                                           this.context.setItem(
                                                                item.code,
                                                                quantity,
                                                                "cordoba"
                                                            )}}
                                                    />
                                                </li>
                                            )}
                                        </ul>
                                    )}
                                    <div className="cartHover_price_section d-flex justify-content-around">
                                        <div className="cartHover_price_unitario">
                                            <p className="cartHover_price_label">Precio Unitario</p>
                                            <p className="cartHover_price_value">
                                                ${" "}
                                                {format.FormatPrice(
                                                    item.quantity >= item.OfertaNxM_Cantidad && item.OfertaNxM_Cantidad > 0
                                                        ? item.OfertaNxM_PrecioSinIVA
                                                        : item.precioSinIVA
                                                )}
                                            </p>
                                        </div>
                                        <div className="cartHover_price_total">
                                            <p className="cartHover_price_label">Precio Total</p>
                                            <p className="cartHover_price_value">
                                                ${" "}
                                                {format.FormatPrice(
                                                    (item.quantity >= item.OfertaNxM_Cantidad && item.OfertaNxM_Cantidad > 0
                                                        ? item.OfertaNxM_PrecioSinIVA
                                                        : item.precioSinIVA) * item.quantity
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className='cartHover_empty'>
                                <h1>Carrito vacío</h1>
                                <img
                                    width={100}
                                    height={100}
                                    src={emptycart}
                                    alt={"Carrito vacio"}
                                />
                            </div>
                        )}
                        {cartItems.length > 0 && (
                            <div>
                                <FreeShipping totalPrice={format.FormatPrice(total)} onRemainingAmount={this.handleRemainingAmount} onFreeShippingChange={this.handleFreeShippingChange} type={'cart-menu'}/>
                                <div className="container">
                                <div className="row justify-content-end text-right mb-2">
                                    <div className="col-12 col-md-8">
                                        <div className="subtotal">
                                            Subtotal: ${format.FormatPrice(subtotal)}
                                        </div>
                                        <div className="iva mb-2">
                                            IVA 21%: ${format.FormatPrice(montoIVA)}
                                        </div>
                                        <h2 className="text-muted ">
                                            Total: ${format.FormatPrice(total)}
                                        </h2>
                                    </div>
                                </div>
                            </div>

                                <button
                                    className="cartHover_button btn"
                                    onClick={e => {
                                        e.preventDefault();
                                        Swal.fire({
                                            title: "¿Vaciar el carrito?",
                                            text: "¿Está seguro de que desea vaciar el carrito?",
                                            icon: "warning",
                                            showCancelButton: "true",
                                            cancelButtonText: "Cancelar",
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText: "Sí, vaciar el carrito!"
                                        }).then(result => {
                                            if (result.isConfirmed) {
                                                this.context.removeAllItems(() => {
                                                    this.setState({
                                                        loaded: false
                                                    });
                                                });
                                                Swal.fire({
                                                    title: "¡El carrito ha sido vaciado!",
                                                    icon: "success",
                                                    showConfirmButton: false,
                                                    timer: 1200,
                                                  });
                                            }
                                        });
                                    }}> Vaciar Carrito </button>
                            </div>
                        )}
                    </div>
                </LoadingScreen>
            </div>
        );
    }
}

export default CartMenu;



// WEBPACK FOOTER //
// ./src/views/Cart/CartMenu.js